import { apiSlice } from "./features/apiSlices/apiSlice"
import modeReducer from "./features/slices/modeSlice"
import productReducer from "./features/slices/productSlice"
import bookingReducer from "./features/slices/bookings"
import customerReducer from "./features/slices/customer"
import setupReducer from "./features/slices/setup"
import saleReducer from "./features/slices/invoices/sale"
import paymentReducer from "./features/slices/payment"
import accountsReducer from "./features/slices/accounts"
import userReducer from "./features/slices/user"
import deviceReducer from "./features/slices/deviceSlices"
import { configureStore } from "@reduxjs/toolkit";

const store = configureStore({
    reducer:{
        mode: modeReducer,
        product:productReducer,
        booking:bookingReducer,
        customer:customerReducer,
        setup:setupReducer,
        sale:saleReducer,
        payment:paymentReducer,
        accounts:accountsReducer,
        user:userReducer,
        device: deviceReducer,
        [apiSlice.reducerPath]: apiSlice.reducer
    },
    devTools:true,
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
})

export default store;